// extracted by mini-css-extract-plugin
module.exports = {"main":"HidekiInfoView_main_3D38W","main_title":"HidekiInfoView_main_title_3w8QU"};